import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IProduct } from 'src/app/models/products/product';
import { IMasterSuite } from 'src/app/models/mastersuites/mastersuite';

@Component({
  selector: 'app-batch-actions-dropdown',
  templateUrl: './batch-actions-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class BatchActionsDropdownComponent {
  @Input() products: IProduct[] = [];
  @Input() masterSuites: IMasterSuite[] = [];
  @Output() actionComplete = new EventEmitter<void>();

  sectionVisible: Record<string, boolean> = {};

  get hasAnyPermission(): boolean {
    return Object.values(this.sectionVisible).some((v) => v);
  }

  onChildVisibility(section: string, visible: boolean): void {
    if (visible) this.sectionVisible[section] = true;
  }
}
